<template>
  <div class="swiper" :style="{ width: '100%'}">
    <!-- style="swiperStyle" -->
    <!-- pc -->
    <div v-if="mobileShow" class="swiper_banner1" style="width: 100%; position: absolute; top: 0; left:0; z-index: 100">
      <el-carousel arrow="hover" :height="mobileShow ? '420px' : '200px'">
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <a :href="item.imgBannerUrl" :target="item.type === 345 ? '_blank' : '_blank'">
            <!-- <img style="width: 100%; height: 100%; display: inline-block" :src="$path+item.url" alt="" /> -->
            <div class="swiper-img" :style="'background-image: url(' + $path+item.url +')'"></div>
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- mobile -->
    <div v-else class="swiper_banner2 swiper-container filmswiper" ref="filmswiper" style="background: #eaebee;">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in imgList" :key="index">
          <a :href="item.imgBannerUrl" :target="item.type === 345 ? '_blank' : '_slef'">
            <img style="width: 100%; height: 100%; display: inline-block" :src="$path+item.url" alt="" />
          </a>
        </div>
      </div>

      <!-- 如果需要分页器 -->
      <div class="swiper-pagination swiperpPagination" slot="pagination"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
import 'swiper/dist/js/swiper.js'
export default {
  name: "swiper",
  computed: {
    ...mapState(['screenWidth']),
    mobileShow () {
      if (this.screenWidth <= 1024) {
        return false
      } else {
        return true
      }
    }
  },
  data () {
    return {
      showStatus: 0,
      imgList: [],
    }
  },
  created () {
    const obj = {
      type: 0
    }
    if (document.documentElement.clientWidth < 900) {
      obj.type = 1
    } else {
      obj.type = 0
    }
    this.$api.iotHome.getBanner(obj).then((res) => {
      if (res.data.success == true) {
        this.imgList = res.data.data.map(item => {
          let imgBannerUrl = ''
          switch (item.jumpType) {
            case 1:
              imgBannerUrl = `/detectionDetail?id=${item.jumpInfo}`
              break;
            case 2:
              imgBannerUrl = `/detection?id=${item.jumpInfo}`
              break;
            case 3:
              imgBannerUrl = `/services?columnId=${item.jumpInfo}`
              break;
            case 4:
              imgBannerUrl = `/enterpriseDetail?id=${item.jumpInfo}`
              break
            case 5:
              imgBannerUrl = `/toolsDetail?id=${item.jumpInfo}`
              break
            case 6:
              imgBannerUrl = `/toolsDetail?id=${item.jumpInfo}`
              break
            case 7:
              imgBannerUrl = item.jumpInfo
              break
            case 345:
              imgBannerUrl = item.jumpInfo
              break
          }
          return {
            ...item,
            imgBannerUrl: imgBannerUrl
          }
        })
      }
    });
  },
  mounted () {
    // this.mouseleave();
    if (this.$refs.filmswiper) {
      new Swiper('.filmswiper', {
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        bulletElement: 'li',
        observeParents: true,
        observer: true,
        autoplay: true,
        slidesPerView: 'auto',
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        effect: "slide",
      })
    }
  },
  methods: {
    // 鼠标移入
    mouseover (index) {
      this.showStatus = index;
      this.showTitle = this.swiperMenuList[index].name;
      this.children = this.swiperMenuList[index].children;
      this.$refs.none.style.display = "block";
      if (this.$refs.none.style.display == "block") {
        this.$refs.cloever[index].style.background = "rgba(255, 255, 255, 1)";
      }
    },
    // 鼠标移出
    mouseleave (event) {
      this.$refs.cloever[this.showStatus].style.background =
        "rgba(255, 255, 255, 0.9)";
      this.$refs.none.style.display = "none";
    },
    onClick (data) {
      // if(data.href!=""){
      //     window.open(data.href,"__target__");
      // }
    },
    tolist (id) {
      window.localStorage.setItem('defaultActive', id);
      this.$router.push({
        path: '/detection'
      });
    },
  },
};
</script>

<style lang="scss">
/* 手机端 */
@media all and (max-width: 960px) {
  .swiper {
    height: 200px;
  }
  .swiper_banner1 {
    display: none !important;
  }
  .swiper_banner2 {
    display: block !important;
    height: 4rem !important;
  }
}
/* PC端 */
@media all and (min-width: 960px) {
  .swiper {
    height: 460px !important;
    //   height: 420px!important;
    background: #eaebee;
  }
  .swiper_banner1 {
    display: block !important;
    height: 460px !important;
    // height: 28.6vw!important;
    .el-carousel__container {
      height: 460px !important;
      // height: 28.6vw!important;
    }
  }
  .swiper_banner2 {
    display: none !important;
  }
}
.swiper_banner1 {
  .el-carousel__arrow--left {
    left: 10% !important;
  }
  .el-carousel__arrow--right {
    right: 10% !important;
  }
}
</style>

<style>
.swiperpPagination .swiper-pagination-bullet-active {
  width: 0.08rem !important;
  height: 0.08rem !important;
  border-radius: 50% !important;
}
.swiperpPagination .swiper-pagination-bullet {
  width: 0.08rem !important;
  height: 0.08rem !important;
  border-radius: 50% !important;
}
.swiper {
  width: 100%;
  height: calc(100vw * 420 / 1200);
}
.el-carousel__indicators--horizontal {
  bottom: 0;
}
.el-carousel__button {
  width: 6px !important;
  height: 6px !important;
  border-radius: 50%;
}
.el-carousel__arrow {
  background-color: rgba(255, 255, 255, 0.7);
}
.el-carousel__arrow:hover {
  background-color: rgba(255, 255, 255, 0.7);
}
.el-carousel__arrow i {
  color: #333;
}
.el-carousel__indicator--horizontal {
  display: inline-block;
  padding: 30px 10px;
}
.swiper-button-prev,
.swiper-button-next {
  background-color: rgba(255, 255, 255, 0.7);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 10px;
}

.clo_ever {
  width: 100%;
  height: 64px;
  padding-top: 10px;
  padding-left: 30px;
  cursor: pointer;
  position: relative;
  background: rgba(255, 255, 255, 0.9);
}

.clo_ever:hover {
  background: rgba(255, 255, 255, 1);
}

.ever_none {
  width: 520px;
  height: 448px;
  background: #ffffff;
  /* display: none; */
}

.ever_none_title {
  width: 420px;
  margin-left: 50px;
  margin-top: 31px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dcdfe6;
}

.ever_none_title_text {
  font-size: 18px;
  font-weight: 700;
  color: #0076c6;
  padding-bottom: 10px;
  border-bottom: 4px solid #0076c6;
}

.ever_none_content {
  width: 420px;
  margin-left: 50px;
}

.ever_none_content > p {
  display: inline-block;
  margin-right: 20px;
  line-height: 41px;
  cursor: pointer;
}

.clo_ever_img {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  left: 5px;
}

.clo_ever_title:hover {
  color: #0076c6 !important;
}

.clo_ever_text:hover {
  color: #0076c6 !important;
}

.clo_box {
  width: 227px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ever_none_text:hover {
  color: #0076c6 !important;
}

.swiper-img {
  width: 100vw;
  height: 460px;
  background-repeat: no-repeat;
  background-size: cover;
  background-origin: 50% 50%;
}

.el-carousel__indicators {
  display: none;
}
</style>
